import additiveChangeCompany from './companyChangeTerm';import discharge from './dischargeTerm';
import additiveRenovation from './renewalTerm';
import contract from './serviceProvisionContract';
import confidentiality from './termOfConfidentiality';
import distractByTheContractor from './terminationByTheContractor';
import distractMutualAgreement from './terminationMutualAgreement';
import additiveValueAdjustment from './valueAdjustmentTerm';
import borrowedNoteDeclaration from './borrowedNoteDeclaration';
import companyContractCSP from '../clicksignDocumentCompanyTemplates/CSP';
import companyContractManagedServices from '../clicksignDocumentCompanyTemplates/ManagedServices';
import companyContractVolume12Meses from '../clicksignDocumentCompanyTemplates/Volume12Meses';
import companyContractVolume36Meses from '../clicksignDocumentCompanyTemplates/Volume36Meses';


const templates = {
    additiveChangeCompany: additiveChangeCompany,
    discharge: discharge,
    additiveRenovation: additiveRenovation,
    contract: contract,
    confidentiality: confidentiality,
    distractByTheContractor: distractByTheContractor,
    distractMutualAgreement: distractMutualAgreement,
    additiveValueAdjustment: additiveValueAdjustment,
    borrowedNoteDeclaration: borrowedNoteDeclaration,
    companyContractCSP: companyContractCSP,
    companyContractManagedServices: companyContractManagedServices,
    companyContractVolume12Meses: companyContractVolume12Meses,
    companyContractVolume36Meses: companyContractVolume36Meses,
    default: ''
}

export default templates;



// WEBPACK FOOTER //
// ./src/app/shared/documents/templates/clicksignDocumentTemplates/index.ts